import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES } from 'app-webtech-core/beacon/const';

/*
Fires whenever buffering ends on a client
 */

export const playerBufferEndBeacon = () => ({
  hitType: HIT_TYPE.EVENT,
  eventCategory: EVENT_CATEGORIES.QOS,
  eventName: EVENT_NAMES.PLAYER_BUFFER_END,
});
